<div class="flex flex-col gap-6">
  <div class="border-b border-gray-200 pb-3">
    <h2 class="text-lg font-bold text-gray-900" i18n="@@pharmacyHistoryTitle">Request History Log</h2>
  </div>

  @if (loading()) {
    <app-loading />
  } @else if (isError()) {
    <app-error-data [title]="isError()" />
  } @else if (isEmpty()) {
    <app-empty-data [title]="isArabic() ? 'لا يوجد سجل طلبات بعد.' : 'No request history yet.'" />
  } @else {
    <div
      class="relative pb-4"
      [ngClass]="isArabic() ? 'mr-4 border-r-2 border-gray-200 pr-8' : 'ml-4 border-l-2 border-gray-200 pl-8'">
      @for (log of historyLogs(); track log.id; let last = $last) {
        <div class="relative mb-5 last:mb-0">
          <div
            class="bg-green absolute top-0 z-10 flex h-6 w-6 items-center justify-center rounded-full shadow-sm"
            [ngClass]="isArabic() ? '-right-[43px]' : '-left-[43px]'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>

          <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2">
              <div class="w-[200px]">
                <h3 class="text-base leading-tight font-bold text-gray-900">
                  {{ getTranslatedTitle(log.event) }}
                </h3>
              </div>
              <div class="flex-shrink-0">
                <app-status-badge
                  [status]="log.nextStatus.titleEn"
                  [displayText]="getTranslatedTitle(log.nextStatus)"
                  size="sm"
                  customClass="px-3 h-7 w-[130px]" />
              </div>
            </div>

            <div class="mt-1 flex items-center gap-6 text-sm text-gray-500">
              @if (log.executedBy) {
                <div class="flex items-center gap-1.5">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    class="text-gray-400">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span>{{ log.executedBy.fullName }}</span>
                </div>
              }
              @if (log.executedOn) {
                <div class="flex items-center gap-1.5" dir="ltr">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    class="text-gray-400">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  <span class="text-[12px] font-medium">{{ log.executedOn | date }}</span>
                </div>
              }
            </div>

            @if (log.comment) {
              @if (log.nextStatus.titleEn?.toLowerCase()?.trim() === "feedback needed") {
                <div
                  class="mt-2 rounded-md bg-violet-50 px-3 py-2.5"
                  [ngClass]="isArabic() ? 'border-r-2 border-violet-300' : 'border-l-2 border-violet-300'">
                  <p class="text-[13px] leading-relaxed break-words text-gray-600">{{ log.comment }}</p>
                </div>
              } @else {
                <p
                  class="mt-1 text-[13px] leading-relaxed break-words text-gray-500"
                  [ngClass]="isArabic() ? 'border-r-2 border-gray-100 pr-3' : 'border-l-2 border-gray-100 pl-3'">
                  {{ log.comment }}
                </p>
              }
            }
          </div>

          @if (!last) {
            <div class="mt-4 border-b border-gray-100/50"></div>
          }
        </div>
      }
    </div>
  }
</div>
